import { FullScreen } from '@modals/layout'
import { Center } from '@shared/components/layout'

import { CompleteDepositContent } from './CompleteDeposit.content'

import type { SupportedChainId } from '@shared/wallet/constants/chain'

export interface CompleteDepositProps {
  /**
   * Chain ID.
   */
  chainId?: SupportedChainId
}

export const CompleteDeposit: React.FC<CompleteDepositProps> = ({
  chainId,
}) => {
  return (
    <FullScreen totalSteps={5}>
      <Center className="font-circular" variant="horizontal">
        {chainId != null && <CompleteDepositContent chainId={chainId} />}
      </Center>
    </FullScreen>
  )
}
